import React from 'react';
import { FileUploadForm } from '../components/file-upload-form';
import { useClipboardStore } from '../utils/clipboard.store';
import { shallow } from 'zustand/shallow';

type Props = {
  onNewFile: (file: File) => void;
};

export const AddFileControlPanelContent = ({ onNewFile }: Props) => {
  const currentClipboardData = useClipboardStore((state) => state.currentClipboardData, shallow);
  const autoGenerate = useClipboardStore((state) => state.autoGenerate, shallow);
  const revokeAutoGenerate = useClipboardStore((state) => state.revokeAutoGenerate);

  return (
    <FileUploadForm
      autoGenerate={autoGenerate}
      clipboardData={currentClipboardData}
      onUploadCLipboardFile={revokeAutoGenerate}
      onNewFile={onNewFile}
      accept={undefined}
    />
  );
};
